import { ScheduleType, type BackupPolicyConfig } from '@repo/api-gw-sdk';
import { v4 as uuid } from 'uuid';

import { MIN_WINDOW_HOURS } from '../controls/hoursSelector';
import { dailyFrequency } from '../frequency';

export const defaultBackupPolicy: BackupPolicyConfig = {
  name: '',
  exclude: [],
  include: [],
  enabled: true,
  schedules: [
    {
      id: uuid(),
      duration: MIN_WINDOW_HOURS * 60,
      backupRetention: dailyFrequency.defaultRetentionInDays,
      vaultId: '',
      windows: dailyFrequency.windows,
      scheduleType: ScheduleType.SCHEDULE_TYPE_STANDARD,
    },
  ],
  attachedResources: 0,
  id: '',
  dateCreated: new Date(),
  dateModified: new Date(),
  userCreated: '',
};
